export enum CurrencyCodes {
  AUD = 'AUD',
  BRL = 'BRL',
  GBP = 'GBP',
  CNY = 'CNY',
  DKK = 'DKK',
  EUR = 'EUR',
  HKD = 'HKD',
  IDR = 'IDR',
  JPY = 'JPY',
  MYR = 'MYR',
  TWD = 'TWD',
  NOK = 'NOK',
  PHP = 'PHP',
  SGD = 'SGD',
  KRW = 'KRW',
  SEK = 'SEK',
  THB = 'THB',
  USD = 'USD',
}

export const CURRENCY_SYMBOLS = {
  [CurrencyCodes.AUD]: 'A$',
  [CurrencyCodes.BRL]: 'R$',
  [CurrencyCodes.GBP]: '£',
  [CurrencyCodes.CNY]: '¥',
  [CurrencyCodes.DKK]: 'Kr.',
  [CurrencyCodes.EUR]: '€',
  [CurrencyCodes.HKD]: 'HK$',
  [CurrencyCodes.IDR]: 'Rp',
  [CurrencyCodes.JPY]: 'J¥',
  [CurrencyCodes.MYR]: 'RM',
  [CurrencyCodes.TWD]: 'NT$',
  [CurrencyCodes.NOK]: 'kr',
  [CurrencyCodes.PHP]: '₱',
  [CurrencyCodes.SGD]: 'S$',
  [CurrencyCodes.KRW]: '₩',
  [CurrencyCodes.SEK]: 'kr',
  [CurrencyCodes.THB]: '฿',
  [CurrencyCodes.USD]: '$',
};

export const CURRENCY_CODES = {
  A$: CurrencyCodes.AUD,
  R$: CurrencyCodes.BRL,
  '£': CurrencyCodes.GBP,
  '¥': CurrencyCodes.CNY,
  DKr: CurrencyCodes.DKK,
  '€': CurrencyCodes.EUR,
  HK$: CurrencyCodes.HKD,
  Rp: CurrencyCodes.IDR,
  'J¥': CurrencyCodes.JPY,
  RM: CurrencyCodes.MYR,
  NT$: CurrencyCodes.TWD,
  Nkr: CurrencyCodes.NOK,
  '₱': CurrencyCodes.PHP,
  S$: CurrencyCodes.SGD,
  '₩': CurrencyCodes.KRW,
  SKr: CurrencyCodes.SEK,
  '฿': CurrencyCodes.THB,
  $: CurrencyCodes.USD,
};

export const CurrencyAdornments = {
  [CurrencyCodes.AUD]: ['left', CURRENCY_SYMBOLS[CurrencyCodes.AUD]],
  [CurrencyCodes.BRL]: ['left', CURRENCY_SYMBOLS[CurrencyCodes.BRL]],
  [CurrencyCodes.GBP]: ['left', CURRENCY_SYMBOLS[CurrencyCodes.GBP]],
  [CurrencyCodes.CNY]: ['left', CURRENCY_SYMBOLS[CurrencyCodes.CNY]],
  [CurrencyCodes.DKK]: ['left', CURRENCY_SYMBOLS[CurrencyCodes.DKK]],
  [CurrencyCodes.EUR]: ['left', CURRENCY_SYMBOLS[CurrencyCodes.EUR]],
  [CurrencyCodes.HKD]: ['left', CURRENCY_SYMBOLS[CurrencyCodes.HKD]],
  [CurrencyCodes.IDR]: ['left', CURRENCY_SYMBOLS[CurrencyCodes.IDR]],
  [CurrencyCodes.JPY]: ['left', CURRENCY_SYMBOLS[CurrencyCodes.JPY]],
  [CurrencyCodes.MYR]: ['left', CURRENCY_SYMBOLS[CurrencyCodes.MYR]],
  [CurrencyCodes.TWD]: ['left', CURRENCY_SYMBOLS[CurrencyCodes.TWD]],
  [CurrencyCodes.NOK]: ['left', CURRENCY_SYMBOLS[CurrencyCodes.NOK]],
  [CurrencyCodes.PHP]: ['left', CURRENCY_SYMBOLS[CurrencyCodes.PHP]],
  [CurrencyCodes.SGD]: ['left', CURRENCY_SYMBOLS[CurrencyCodes.SGD]],
  [CurrencyCodes.KRW]: ['left', CURRENCY_SYMBOLS[CurrencyCodes.KRW]],
  [CurrencyCodes.SEK]: ['left', CURRENCY_SYMBOLS[CurrencyCodes.SEK]],
  [CurrencyCodes.THB]: ['left', CURRENCY_SYMBOLS[CurrencyCodes.THB]],
  [CurrencyCodes.USD]: ['left', CURRENCY_SYMBOLS[CurrencyCodes.USD]],
  NONE: ['left', ' '],
};
